import { StateCreator } from 'zustand';
import { Store } from 'src/stores/store.interface';
import { WorkflowCreationCommonInputsStoreType } from './workflowCreationCommonInputsStore.interface';

export const defaultWorkflowCreationCommonInputsStore = {
	commonTaskInputs: [],
};

const workflowCreationCommonInputsStore: StateCreator<
	Store,
	[],
	[],
	WorkflowCreationCommonInputsStoreType
> = (set) => ({
	...defaultWorkflowCreationCommonInputsStore,
	setCommonTaskInputs: (commonTaskInputs) => set({ commonTaskInputs }),
});

export default workflowCreationCommonInputsStore;
